import React, {Component} from 'react';

class SearchBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {title, searchText, onSearchTextChanged} = this.props;

    return (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-btn">
              <span className="input-group-addon">
                <i className="fa fa-search"/> &nbsp;
                {title}
              </span>
            <input type="text" id="searchText" name="searchText" className="form-control"
                   value={searchText} onChange={onSearchTextChanged}/>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/SearchBox/SearchBox.js